import { Box, Flex, Text, keyframes } from '@chakra-ui/react';

const AVATARS = ['🦊', '🐨', '🐰', '🦁', '🐝', '🐿️', '🐼', '🐧', '🦉', '🐢', '🦄', '🐬'];
const ava = (s = '') => AVATARS[[...s].reduce((a, c) => a + c.charCodeAt(0), 0) % AVATARS.length];
const pulse = keyframes`0%{box-shadow:0 0 0 0 rgba(255,82,82,.6)}70%{box-shadow:0 0 0 7px rgba(255,82,82,0)}100%{box-shadow:0 0 0 0 rgba(255,82,82,0)}`;
// [nhãn, màu, có chấm nhấp nháy]
const TAG = {
  active: ['ĐANG ĐẤU', '#FF5252', true],
  open: ['ĐANG CHỜ ĐỐI THỦ', '#38BDF8', false],
  done: ['KẾT THÚC', '#22C55E', false],
  cancelled: ['ĐÃ HUỶ', '#9CA3AF', false],
};

/** MỘT thẻ trận thách đấu dùng CHUNG cho trang Thách đấu + lịch sử ở chi tiết bé. */
export default function BattleCard({ b }) {
  const [label, color, pulsing] = TAG[b.status] || TAG.open;
  const decided = b.status === 'done' && b.winnerChildId;
  const hostRes = decided ? (b.winnerChildId === b.host?.id ? 'win' : 'lose') : null;
  const guestRes = decided ? (b.winnerChildId === b.guest?.id ? 'win' : 'lose') : null;
  return (
    <Box position="relative" borderRadius="18px" p="16px" color="#fff" overflow="hidden"
      bg="radial-gradient(120% 120% at 50% -10%,#3a2a7a,#150f2e 65%)" boxShadow="0 16px 40px rgba(0,0,0,.35)">
      <Box position="absolute" inset="0" bg="radial-gradient(300px 120px at 15% 20%,rgba(56,189,248,.25),transparent),radial-gradient(300px 120px at 85% 20%,rgba(251,113,133,.25),transparent)" />
      <Box position="relative">
        <Flex align="center" mb="10px" gap="8px">
          <Flex align="center" gap="7px" fontSize="10.5px" fontWeight="800" letterSpacing=".08em"
            bg={`${color}33`} border={`1px solid ${color}80`} px="10px" py="4px" borderRadius="99px">
            {pulsing && <Box w="7px" h="7px" borderRadius="full" bg={color} animation={`${pulse} 1.2s infinite`} />}
            {label}</Flex>
          {b.createdAt && <Text ml="auto" fontSize="11px" opacity="0.7" whiteSpace="nowrap">📅 {new Date(b.createdAt).toLocaleDateString('vi-VN')}</Text>}
        </Flex>
        <Flex align="flex-start" justify="space-between" gap="10px" my="6px">
          <Side name={b.host?.name} avatar={b.host?.avatar} hp={b.count - b.guestHits} total={b.count} host result={hostRes} />
          <Box textAlign="center" pt="14px" flexShrink="0">
            <Text fontWeight="850" color="#FFCF4A" fontSize="15px">{b.wager} <Box as="span" fontSize="20px" verticalAlign="middle">💎</Box></Text>
            <Text fontWeight="850" fontSize="15px" opacity="0.9">VS</Text>
          </Box>
          <Side name={b.guest?.name} avatar={b.guest?.avatar} hp={b.count - b.hostHits} total={b.count} result={guestRes} />
        </Flex>
      </Box>
    </Box>
  );
}

function Side({ name, avatar, hp, total, host, result }) {
  const won = result === 'win', lost = result === 'lose';
  const glow = won ? 'rgba(255,207,74,.75)' : host ? 'rgba(56,189,248,.5)' : 'rgba(251,113,133,.5)';
  const bar = host ? 'linear-gradient(90deg,#22d3ee,#38bdf8)' : 'linear-gradient(90deg,#fb7185,#f43f5e)';
  const empty = !name;
  return (
    <Box textAlign="center" flex="1" minW="0">
      <Flex w="56px" h="56px" borderRadius="full" mx="auto" mb="7px" align="center" justify="center" fontSize="28px"
        bg="whiteAlpha.200" boxShadow={`0 0 0 3px ${glow}`} opacity={lost ? 0.55 : 1}>{empty ? '❓' : (avatar || ava(name))}</Flex>
      <Text fontWeight="800" fontSize="14px" noOfLines={1} color={won ? '#FFCF4A' : lost ? 'whiteAlpha.700' : '#fff'}>{empty ? 'Chờ…' : name}</Text>
      {result && (
        <Text display="inline-block" mt="4px" fontSize="9.5px" fontWeight="900" letterSpacing="1px"
          px="10px" py="3px" borderRadius="99px"
          color={won ? '#2A1C06' : 'whiteAlpha.800'}
          bg={won ? 'linear-gradient(90deg,#FFCF4A,#FF9E2C)' : 'whiteAlpha.200'}
          border={won ? 'none' : '1px solid rgba(255,255,255,.25)'}>{won ? 'WINNER' : 'LOSER'}</Text>
      )}
      <Box mt="6px" h="8px" borderRadius="99px" bg="whiteAlpha.300" overflow="hidden">
        <Box h="100%" w={`${Math.max(0, Math.min(100, (hp / (total || 1)) * 100))}%`} bg={bar} /></Box>
      <Text mt="5px" fontSize="11px" fontWeight="700" opacity="0.85">❤️ {Math.max(0, hp)}</Text>
    </Box>
  );
}
